import type {
  EnvironmentId,
  ManagedThreadWorktree,
  ProjectId,
  ThreadId,
} from "@afar-research/contracts";

import { appAtomRegistry } from "../rpc/atomRegistry";
import { worktreeEnvironment } from "../state/worktrees";

export function resolveManagedWorktreeName(input: {
  readonly worktrees: ReadonlyArray<ManagedThreadWorktree>;
  readonly threadId: ThreadId;
  readonly worktreePath: string | null;
}): string | null {
  if (input.worktreePath === null) return null;
  const worktree =
    input.worktrees.find((candidate) => candidate.threadIds.includes(input.threadId)) ??
    input.worktrees.find((candidate) => candidate.path === input.worktreePath);
  const name = worktree?.name?.trim();
  return name && name.length > 0 ? name : null;
}

export function refreshAvailableProjectWorktrees(
  environmentId: EnvironmentId,
  projectIds: ReadonlyArray<ProjectId>,
): void {
  for (const projectId of new Set(projectIds)) {
    appAtomRegistry.refresh(
      worktreeEnvironment.available({
        environmentId,
        input: { projectId },
      }),
    );
  }
}

export function refreshWorktreeInventories(
  environmentId: EnvironmentId,
  projectIds: ReadonlyArray<ProjectId>,
): void {
  refreshAvailableProjectWorktrees(environmentId, projectIds);
  appAtomRegistry.refresh(worktreeEnvironment.managed({ environmentId, input: {} }));
}
